import CryptoJS from 'crypto-js';

function encryptData(parameter) {
    let key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY_ENC_STR);
    let iv  = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_ENC_STR);
    let text = parameter
    
    
    let encryptedCP = CryptoJS.AES.encrypt(text, key, { iv: iv });
    let cryptText = encryptedCP.toString();
    return cryptText;
}

export default encryptData
